import React from 'react';
import SmsSender from './sms-sender';
import { SmsHistoryList } from './sms-history-list';

export const SmsComponent = () => {
  return (
    <div className="container-fluid vh-100 d-flex flex-column p-3">
      <div className="mb-3">
        <SmsSender />
      </div>

      <div className="flex-grow-1 overflow-auto border rounded p-3 bg-light">
        <SmsHistoryList />
      </div>
    </div>
  );
};
